import React from "react";
import {compose} from "redux";
import {firestoreConnect} from "react-redux-firebase";
import {connect} from "react-redux";
import {Button, Col, Row, Form, Input, AutoComplete } from "antd";
import {createFAQ} from "../../Store/Actions/admin";
import {
    PlusOutlined
} from '@ant-design/icons';


class JobRequests extends React.Component {

    state = {
        loading: false
    }

    onFinish = values => {
        this.setState({ loading: true });
        createFAQ(values, res => {
            this.setState({ loading: false });
        })
    }

    render() {
        const { loading } = this.state;
        const { faqs, categories } = this.props;


        return (
            <div>
                <div>
                    <Row className={"uk-width-1-1"}>
                        <Col span={20}>
                            <div>
                                <h3 className="uk-h3 uk-margin-remove">
                                    Jobs requests
                                </h3>
                                <p className="uk-text-small uk-margin-remove">
                                    { categories.length} topics
                                </p>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div className="uk-text-right">
                                <Button uk-toggle="target: #toggle-animation; animation: uk-animation-fade" type="primary">
                                    New <PlusOutlined />
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div id="toggle-animation" className="uk-margin-small uk-padding-small uk-border-rounded uk-background-muted" hidden="true">
                    <Form layout="vertical" onFinish={this.onFinish}>
                        <h3 className="uk-h4 uk-margin-small-bottom">
                            New FAQ
                        </h3>
                        <Form.Item
                            name="question"
                            label="Question"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input.TextArea autoSize={{ maxRows: 2 }} placeholder="Enter question" />
                        </Form.Item>
                        <Form.Item
                            name="topic"
                            label="Topic"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <AutoComplete
                                options={categories}
                                filterOption={(inputValue, option) =>
                                    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                }
                                placeholder="Category"
                            />
                        </Form.Item>
                        <Form.Item
                            name="answer"
                            label="Answer"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input.TextArea autoSize={{ maxRows: 8 }} placeholder="Enter answer" />
                        </Form.Item>

                        <Form.Item>
                            <Button disabled={loading} loading={loading} type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </div>

                <div className="uk-margin-top">
                    <ul className="uk-list uk-list-divider">
                        { faqs.map(faq => (
                            <li>
                                <dt>
                                    <h4 className="uk-h5 uk-margin-remove">
                                        { faq.question }
                                    </h4>
                                    <p className="uk-p uk-text-uppercase uk-margin-remove">
                                        { faq.topic }
                                    </p>
                                </dt>
                                <dd>
                                    { faq.answer }
                                </dd>
                            </li>
                        ))}
                    </ul>
                </div>

            </div>
        );
    }
}



const mapStateToProps = (state) => {
    const faqs = state.firestore.ordered.faqs ? state.firestore.ordered.faqs : [];
    let categories = [];
    faqs.forEach(faq => {
        if(!categories.includes(faq.topic)) {
            categories.push(faq.topic);
        }
    })

    return {
        auth: state.firebase.auth,
        faqs: faqs,
        categories: categories.map(category => {
            return {
                text: category,
                value: category
            }
        })
    }
}

const enhance = compose(
    firestoreConnect([
        { collection: "faqs" }
    ]),
    connect(mapStateToProps)
);
export default enhance(JobRequests);



// WEBPACK FOOTER //
// ./src/Components/Admin/JobRequests.js